"use strict";

var TooltipsDatatable = function () {

    var handleTooltipsDatatable = function () {

        tippy('.tooltip-title', {
            content(reference) {
                const data = reference.getAttribute('data-template');
                let result = '';
                if (data) {
                    const template = document.getElementById(data);
                    result = template.innerHTML;
                } else {
                    result = reference.getAttribute('data-title');
                    result = '<p>' + result + '</p';
                }
                return result;
            },
            theme: 'light',
            allowHTML: true,
        });

    };

    return {
        //main function to initiate the function
        init: function() {
            handleTooltipsDatatable();
        }
    };

}();

// webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = TooltipsDatatable;
}